import {
	MEET_THE_TEAM_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'
import Adrian from 'root/src/client/public/teamMembers/Adrian.png'
import Piotr from 'root/src/client/public/teamMembers/Piotr.jpg'
import Alex from 'root/src/client/public/teamMembers/Bottiglio.jpg'
import Arianna from 'root/src/client/public/teamMembers/Arianna.jpg'
import Lukasz from 'root/src/client/public/teamMembers/Lukasz.jpg'
import Wojciech from 'root/src/client/public/teamMembers/Wojciech.jpeg'
import Domo from 'root/src/client/public/teamMembers/Domo.jpeg'
import Joe from 'root/src/client/public/teamMembers/Joe.jpeg'
import Paul from 'root/src/client/public/teamMembers/Paul.jpeg'
import Jason from 'root/src/client/public/teamMembers/Jason.jpg'
import Chris from 'root/src/client/public/teamMembers/Chris.jpg'
import Zan from 'root/src/client/public/teamMembers/Zan.jpeg'
import Fernando from 'root/src/client/public/teamMembers/fernando_young.jpg'
import Mercedes from 'root/src/client/public/teamMembers/mercedes_boberg.jpg'
import Mateusz from 'root/src/client/public/teamMembers/Mateusz.jpg'
import Ryan from 'root/src/client/public/teamMembers/ryan_chahda.png'
import aboutUs3 from 'root/src/client/public/backgroundBlobs/aboutUs3.svg'
import { ltMdMediaQuery } from 'root/src/client/web/commonStyles'

export default {
	[MEET_THE_TEAM_MODULE_ID]: {
		moduleType: 'static',
		staticPageType: 'meetTheTeam',
		backgroundData: [
			{
				position: 'right',
				image: aboutUs3,
				style: {
					transform: 'translate(55%, 100%)',
					zIndex: 2,
					'@media(max-width: 1540px)': {
						transform: 'translate(70%, 90%)',
					},
					'@media(max-width: 1400px)': {
						transform: 'translate(80%, 90%)',
					},
					[ltMdMediaQuery]: {
						transform: 'translate(55%, 150%)',
					},
				},
			},
		],
		pageContent: {
			title: 'MEET THE TEAM',
			members: [
				{
					img: Joe,
					name: 'Joe',
					role: 'Co-Founder',
				},
				{
					img: Paul,
					name: 'Paul',
					role: 'Co-Founder',
				},
				{
					img: Domo,
					name: 'Domo',
					role: 'Lead Developer',
				},
				{
					img: Jason,
					name: 'Jason',
					role: 'VP of Business Development',
				},
				{
					img: Fernando,
					name: 'Fernando',
					role: 'Director of Creator Strategy',
				},
				{
					img: Mercedes,
					name: 'Mercedes',
					role: 'Creator Marketing Strategist',
				},
				{
					img: Ryan,
					name: 'Ryan',
					role: 'Director of Creator Strategy',
				},
				{
					img: Chris,
					name: 'Chris',
					role: 'UX Designer',
				},
				{
					img: Piotr,
					name: 'Piotr',
					role: 'Developer',
				},
				{
					img: Wojciech,
					name: 'Wojciech',
					role: 'Developer',
				},
				{
					img: Adrian,
					name: 'Adrian',
					role: 'Developer',
				},
				{
					img: Lukasz,
					name: 'Lukasz',
					role: 'Developer',
				},
				{
					img: Mateusz,
					name: 'Mateusz',
					role: 'Developer',
				},
				{
					img: Zan,
					name: 'Zan',
					role: 'Account Manager',
				},
				{
					img: Alex,
					name: 'Alex',
					role: 'Social Media & Community Manager',
				},
				{
					img: Arianna,
					name: 'Arianna',
					role: 'Community Manager & Influencer Manager',
				},
			],
		},
	},
}
